const AdmissionErrorCodes = {
  ADM00001: 'This Worker Id already exists. Please choose a different one',
  ADM00002: 'This Matricula Id already exists. Please choose a different one',
  ADM00003: 'PersonId already exists',
  ADM00004: 'User already exists.',
  ADM00005: 'User already set permanent password.',
} as const;

export default AdmissionErrorCodes;
